<div class="row">
  @if (showThumbnails) {
    <div class="col-3 col-md-2 pe-sm-0">
      @if (linkType !== linkTypes.None) {
        <a [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
          [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
          [routerLink]="[itemPageRoute]" class="dont-break-out" tabindex="-1">
          <ds-thumbnail [thumbnail]="dso?.thumbnail | async"
            [defaultImage]="'assets/images/project-placeholder.svg'"
            [alt]="'thumbnail.project.alt'"
            [placeholder]="'thumbnail.project.placeholder'">
          </ds-thumbnail>
        </a>
      }
      @if (linkType === linkTypes.None) {
        <span class="dont-break-out">
          <ds-thumbnail [thumbnail]="dso?.thumbnail | async"
            [defaultImage]="'assets/images/project-placeholder.svg'"
            [alt]="'thumbnail.project.alt'"
            [placeholder]="'thumbnail.project.placeholder'">
          </ds-thumbnail>
        </span>
      }
    </div>
  }
  <div [ngClass]="showThumbnails ? 'col-9 col-xl-10' : 'col-md-12'">
    <div class="d-flex justify-content-between">
      <div class="flex-fill">
        <ds-truncatable [id]="dso.id">
          @if (showLabel) {
            <ds-badges [object]="dso" [context]="context"></ds-badges>
          }
          @if (linkType !== linkTypes.None) {
            <a [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
              [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
              [routerLink]="[itemPageRoute]" class="lead item-list-title dont-break-out"
            [innerHTML]="dsoTitle | dsEscapeHtml" role="link" tabindex="0"></a>
          }
          @if (linkType === linkTypes.None) {
            <span
              class="lead item-list-title dont-break-out"
            [innerHTML]="dsoTitle | dsEscapeHtml"></span>
          }
          <ds-additional-metadata [object]="dso"></ds-additional-metadata>
        </ds-truncatable>
        @if (showMetrics) {
          <ds-metric-badges class="d-block clearfix" [item]="dso"></ds-metric-badges>
        }
      </div>
      @if (showMetrics) {
        <div class="align-self-center">
          <ds-metric-donuts [item]="dso"></ds-metric-donuts>
        </div>
      }
    </div>
</div>
</div>
